import { ApolloError, useQuery } from '@apollo/client';

import {
  GetStandardDeliveryReportQuery,
  GetStandardDeliveryReportQueryVariables,
  StandardDeliveryReport,
} from '../../types';
import { GET_STANDARD_DELIVERY_REPORT } from './getStandardDeliveryReport';

type StandardDeliveryReportResponse = {
  data?: StandardDeliveryReport;
  loading: boolean;
  error?: ApolloError;
};
const useStandardDeliveryReport = (id: string): StandardDeliveryReportResponse => {
  const { data, loading, error } = useQuery<GetStandardDeliveryReportQuery, GetStandardDeliveryReportQueryVariables>(
    GET_STANDARD_DELIVERY_REPORT,
    {
      variables: {
        id,
      },
    }
  );

  return {
    loading,
    error,
    data: data?.getStandardDeliveryReport,
  };
};

export default useStandardDeliveryReport;
